/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Publish_PrivateInputs */

const zh_publish_private = /** @type {(inputs: Publish_PrivateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`私密`)
};

const en_publish_private = /** @type {(inputs: Publish_PrivateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Private`)
};

const es_publish_private = /** @type {(inputs: Publish_PrivateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Privado`)
};

/**
* | output |
* | --- |
* | "Private" |
*
* @param {Publish_PrivateInputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
export const publish_private = /** @type {((inputs?: Publish_PrivateInputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Publish_PrivateInputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_publish_private(inputs)
	if (locale === "en") return en_publish_private(inputs)
	return es_publish_private(inputs)
});